import React from 'react';
import CIcon from '@coreui/icons-react';

const NoChat = () => {
  return (
    <div className="d-flex w-100 flex-grow-1 flex-column align-items-center justify-content-center no-chat-placeholder">
      <CIcon name="cil-speech" size="3xl" className="no-chat-icon" />
      <div className="no-chat-text">Select a chat to start messaging</div>
    </div>
  );
};

export default NoChat;
